<div>&nbsp;&nbsp;&nbsp;</div>
<nav [ngClass]="{sidebarPushRight: isActive, collapsed: collapsed}" class="sidebar">
  <div *ngIf="(menulist) != ''" class="list-group">
    <div *ngFor="let moduleGroup of menulist" class="nested-menu">

      <ng-container (click)="showMenu = ''"
                    *ngIf="moduleGroup.MODULE_GROUP_ACCESS_STAGE == environment.DIRECT_PAGE_ACCESS.toString()">
        <a [routerLinkActive]="['router-link-active']" [routerLink]="[moduleGroup.MODULE_GROUP_PATH]"
           class="list-group-item"
           title="{{ moduleGroup.MODULE_GROUP_NAME | translate }}">
          <i class="{{ moduleGroup.MODULE_GROUP_ICON }}"></i>&nbsp;
          <span>{{ moduleGroup.MODULE_GROUP_NAME | translate }}</span>
        </a>
      </ng-container>

      <a (click)="addExpandClass(moduleGroup.MODULE_GROUP_NAME)"
         *ngIf="moduleGroup.MODULE_GROUP_ACCESS_STAGE  != environment.DIRECT_PAGE_ACCESS.toString()"
         [ngClass]="['list-group-item', showMenu == moduleGroup.MODULE_GROUP_NAME ? 'expand-main-item' : '']"
         title="{{ moduleGroup.MODULE_GROUP_NAME | translate }}">
        <i class="{{ moduleGroup.MODULE_GROUP_ICON }}"></i>&nbsp;
        <span>{{ moduleGroup.MODULE_GROUP_NAME | translate }}</span>
      </a>

      <li [class.expand]="showMenu == moduleGroup.MODULE_GROUP_NAME" [routerLinkActive]="['expand']" class="nested">
        <ul *ngIf="moduleGroup.MODULE_GROUP_ACCESS_STAGE  != environment.DIRECT_PAGE_ACCESS" class="submenu">
          <li *ngFor="let module of moduleGroup.sub_menu;">

            <a [routerLinkActive]="['router-link-active']"
               [routerLink]="[moduleGroup.MODULE_GROUP_PATH + module.MODULE_PATH]"
               title="{{ module.MODULE_NAME | translate }}">
              <i class="{{ module.MODULE_ICON }}"></i>&nbsp;
              <span>{{ module.MODULE_NAME | translate }}</span>&nbsp;
              <span *ngIf="count[module.MODULE_ID] " class="badge badge-primary badge-pill element style"
                    style="margin-right: 5px;">{{ count[module.MODULE_ID] }}</span>
            </a>

          </li>
        </ul>
      </li>
    </div>

  </div>
  <div (click)="toggleCollapsed()" [ngClass]="{collapsed: collapsed}" class="toggle-button">
    <i *ngIf="collapsed" class="fa fa-fw fa-angle-double-right"></i>
    <i *ngIf="!collapsed" class="fa fa-fw fa-angle-double-left"></i>
  </div>
</nav>
